export const mvth = {
    name: 'Museumsverband Thüringen',
    show: false,
    data: require('../../assets/geojson/mv_thueringen'),
    options: {
        style: function () {
            return {
                weight: 1,
                color: '#484950',
                opacity: .75,
                fillColor: '#00919d',
                fillOpacity: .5
            }
        }
    }
};

export const mvsaar = {
    name: 'Museumsverband Saarland',
    show: false,
    data: require('../../assets/geojson/mv_saarland'),
    options: {
        style: function () {
            return {
                weight: 1,
                color: '#333',
                opacity: .75,
                fillColor: '#114094',
                fillOpacity: .5
            }
        }
    }
};

export const mvshhh = {
    name: 'Museumsverband Schleswig-Holstein und Hamburg',
    show: false,
    data: require('../../assets/geojson/mvshhh'),
    options: {
        style: function () {
            return {
                weight: 1,
                color: '#1d3a8f',
                opacity: .75,
                fillColor: '#e30b14',
                fillOpacity: .5
            }
        }
    }
};

export const lvr = {
    name: 'Landschaftsverband Rheinland',
    show: false,
    data: require('../../assets/geojson/lvr'),
    options: {
        style: function () {
            return {
                weight: 1,
                color: '#004f95',
                opacity: .75,
                fillColor: '#a4cd12',
                fillOpacity: .5
            }
        }
    }
};


// WEBPACK FOOTER //
// ./src/components/configs/geojson.js